module.exports = {"id":"208620","name":"Omar Mascarell","rating":"77","photo":"./data/images/photos/2/208620.png","club":{"name":"Eint. Francfort","logo":"./data/images/clubs/Eint.Francfort.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmarMascarell0.json
// module id = 3283
// module chunks = 0